import {
  StyleSheet,
  Text,
  View,
  SafeAreaView,
  Image,
  TextInput,
  TouchableOpacity,
  KeyboardAvoidingView,
  Dimensions,
  ImageBackground,
  ScrollView,
  Modal,
  FlatList,
  TextBase,
} from "react-native";
import React, { useState } from "react";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
// import { useTranslation } from "react-i18next";
import Appstyles from "../../Constants/AppStyles";
import AppColors from "../../Constants/AppColors";
import { useNavigate } from 'react-router-dom';
//import App from "../../../App";
// import Dropblack, { Gender, SpeedLimit } from "../../Components/Dropblack.js";
const Registration = ({ navigation }) => {
  const navigate = useNavigate();
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
  const phoneRegex = /^\d{7,13}$/;
  const countryCodes = [
    // { name: 'India', flag: AppImages.ActiveDiamond, code: '+91' },
    { name: "United States", flag: "🇺🇸", code: "+1" },
    { name: "United Kingdom", flag: "🇬🇧", code: "+44" },
    { name: "Canada", flag: "🇨🇦", code: "+1" },
    { name: "Australia", flag: "🇦🇺", code: "+61" },
    { name: "India", flag: "🇮🇳", code: "+91" },
    { name: "Germany", flag: "🇩🇪", code: "+49" },
    { name: "France", flag: "🇫🇷", code: "+33" },
    { name: "Japan", flag: "🇯🇵", code: "+81" },
    { name: "Brazil", flag: "🇧🇷", code: "+55" },
    { name: "Mexico", flag: "🇲🇽", code: "+52" },
    { name: "Italy", flag: "🇮🇹", code: "+39" },
    { name: "Spain", flag: "🇪🇸", code: "+34" },
    { name: "Netherlands", flag: "🇳🇱", code: "+31" },
    { name: "Sweden", flag: "🇸🇪", code: "+46" },
    { name: "Switzerland", flag: "🇨🇭", code: "+41" },
    { name: "Belgium", flag: "🇧🇪", code: "+32" },
    { name: "Norway", flag: "🇳🇴", code: "+47" },
    { name: "Denmark", flag: "🇩🇰", code: "+45" },
    { name: "Finland", flag: "🇫🇮", code: "+358" },
    { name: "Austria", flag: "🇦🇹", code: "+43" },
    { name: "Greece", flag: "🇬🇷", code: "+30" },
    { name: "South Korea", flag: "🇰🇷", code: "+82" },
    { name: "Russia", flag: "🇷🇺", code: "+7" },
    { name: "China", flag: "🇨🇳", code: "+86" },
    { name: "Turkey", flag: "🇹🇷", code: "+90" },
    { name: "Argentina", flag: "🇦🇷", code: "+54" },
    { name: "Colombia", flag: "🇨🇴", code: "+57" },
    { name: "Chile", flag: "🇨🇱", code: "+56" },
    { name: "Peru", flag: "🇵🇪", code: "+51" },
    { name: "Egypt", flag: "🇪🇬", code: "+20" },
    { name: "Saudi Arabia", flag: "🇸🇦", code: "+966" },
    { name: "United Arab Emirates", flag: "🇦🇪", code: "+971" },
    { name: "South Africa", flag: "🇿🇦", code: "+27" },
    { name: "Nigeria", flag: "🇳🇬", code: "+234" },
    { name: "Kenya", flag: "🇰🇪", code: "+254" },
    { name: "Morocco", flag: "🇲🇦", code: "+212" },
    { name: "Portugal", flag: "🇵🇹", code: "+351" },
    { name: "Ireland", flag: "🇮🇪", code: "+353" },
    { name: "New Zealand", flag: "🇳🇿", code: "+64" },
    { name: "Singapore", flag: "🇸🇬", code: "+65" },
    { name: "Malaysia", flag: "🇲🇾", code: "+60" },
    { name: "Indonesia", flag: "🇮🇩", code: "+62" },
    { name: "Thailand", flag: "🇹🇭", code: "+66" },
    { name: "Philippines", flag: "🇵🇭", code: "+63" },
    { name: "Vietnam", flag: "🇻🇳", code: "+84" },
    { name: "Pakistan", flag: "🇵🇰", code: "+92" },
    { name: "Bangladesh", flag: "🇧🇩", code: "+880" },
    { name: "Sri Lanka", flag: "🇱🇰", code: "+94" },
    { name: "Myanmar", flag: "🇲🇲", code: "+95" },
  ];
  // const { t } = useTranslation(["common"]);
  const [customerName, setCustomerName] = useState("");
  const [customerCity, setCustomerCity] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [customerNameError, setCustomerNameError] = useState(false);
  const [customerCityError, setCustomerCityError] = useState(false);
  const [customerEmailError, setCustomerEmailError] = useState(false);
  const [customerMobileError, setCustomerMobileError] = useState(false);
  const [countryErrorMessage, setCountryErrorMessage] = useState(false);

  const [isSubmitTouched, setIsSubmitTouched] = useState(false);
  const handleSubmit = () => {
    setIsSubmitTouched(true);
    validateForm();
    if (isFormValid) {
      // Process the form submission
      // navigation.navigate("DrawerScreen");
      navigate("/Dashboard/DashboardMap/DashboardDetails/View");
    }
  };
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [firstFieldModalVisible, setFirstFieldModalVisible] = useState(false);
  const [secondFieldModalVisible, setSecondFieldModalVisible] = useState(false);
  const [sharedCountryCode, setSharedCountryCode] = useState("");
  const [secondFieldCountryCode, setSecondFieldCountryCode] = useState("");
  const [searchText, setSearchText] = useState("");

  const getCountryNameFromCode = (code) => {
    const selectedCountry = countryCodes.find(
      (country) => country.code === code
    );
    return selectedCountry ? selectedCountry.name : "";
  };
  const getCountryFlagFromCode = (code) => {
    const selectedCountry = countryCodes.find(
      (country) => country.code === code
    );
    return selectedCountry ? selectedCountry.flag : "";
  };

  const handleSharedCountryCodeChange = (countryCode) => {
    setSharedCountryCode(countryCode);
    setSecondFieldCountryCode(countryCode);
    setSelectedCountry(countryCode);
  };

  const filteredCountryCodes = countryCodes.filter((country) =>
    country.name.toLowerCase().includes(searchText.toLowerCase())
  );

  // ... (Existing code)

  // ... (Existing code)

  // Step 2: Function to handle changes in the contact number field

  const [modalVisible, setModalVisible] = useState(false);
  const validateForm = () => {
    if (
      customerName &&
      customerCity &&
      emailRegex.test(customerEmail) &&
      phoneRegex.test(customerMobile)
    ) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
      setCustomerNameError(!customerName);
      setCustomerCityError(!customerCity && !customerCity.trim());
      setCustomerEmailError(!emailRegex.test(customerEmail));
      setCustomerMobileError(!phoneRegex.test(customerMobile));
      if (selectedCountry) {
        // Perform the submit action
        console.log("Submit action performed");
        // Navigate to login page
        setCountryErrorMessage(""); // Clear the country error message
      } else {
        // Show error messages for the country and address fields
        if (selectedCountry === null) {
          setCountryErrorMessage("Please select a country");
        } else {
          setCountryErrorMessage("");
        }
      }
    }
  };
  const handlePress = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback to home or custom action
      window.location.href = "/";
    }
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "white",
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 1 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View style={Appstyles.fullAlignment}>
          <TouchableOpacity style={[Appstyles.goback]} onPress={handlePress}>
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15, resizeMode: "contain" }}
            />
          </TouchableOpacity>
        </View>
        <Image
          source={AppImages.LoginLogo}
          style={[{ width: 120, height: 36, resizeMode: "contain" }]}
        />
        <View style={{ width: 40 }} />
      </View>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            margin: 20,
            paddingVertical: 20,
            backgroundColor: AppColors.white,
            borderRadius: 10,
          }}
        >
          <View
            style={{
              borderBottomColor: "#ACACAC",
              borderBottomWidth: 0.5,
              marginHorizontal: 20,
              // flex:1
            }}
          >
            <Text
              style={[
                Appstyles.EmailidTxt,
                {
                  textAlign: "center",
                  fontSize: 18,
                  fontStyle: AppFonts.OverpassSemiBold,
                  marginBottom: 10,
                },
              ]}
            >
              {/* {t("common:translation.Try it for free")} */}
              Try it for free
            </Text>
          </View>
          <View style={{ marginTop: 20 }}>
            <Text
              style={[Appstyles.EmailidTxt, { marginTop: 10, marginLeft: 20 }]}
            >
              {/* {t("common:translation.Name ")} */}
              Name
              <Text style={{ color: AppColors.red }}>*</Text>
            </Text>

            <TextInput
              style={Appstyles.EmailTextinput}
              onChangeText={(text) => {
                setCustomerName(text);
                validateForm();
              }}
              value={customerName}
              // placeholder={t("common:translation.Enter Name here...")}
              placeholder={"Enter Name here..."}
              placeholderTextColor={AppColors.dualbrown}
              //  keyboardType="numeric"
            />
            {customerNameError && isSubmitTouched && (
              <Text
                style={{
                  color: "red",
                  marginRight: 20,
                  fontSize: 10,
                  fontFamily: AppFonts.OverpassRegular,
                  textAlign: "right",
                }}
              >
                {/* {t("common:translation.Field is required")} */}
                Field is required
              </Text>
            )}
          </View>
          <View style={{ marginTop: 20 }}>
            <Text style={[Appstyles.EmailidTxt, { marginLeft: 20 }]}>
              {/* {t("common:translation.Email ID ")} */}
              Email ID
              <Text style={{ color: AppColors.red }}>*</Text>
            </Text>

            <TextInput
              style={[Appstyles.EmailTextinput]}
              onChangeText={(text) => {
                setCustomerEmail(text);
                validateForm();
              }}
              value={customerEmail}
              // placeholder={t("common:translation.Enter you Email ID ")}
              placeholder={"Enter you Email ID"}
              placeholderTextColor={AppColors.dualbrown}
              textAlignVertical="top"
              //  keyboardType="numeric"
            />
            {customerEmailError && isSubmitTouched && (
              <Text
                style={{
                  color: "red",
                  marginRight: 20,
                  fontSize: 10,
                  fontFamily: AppFonts.OverpassRegular,
                  textAlign: "right",
                }}
              >
                {/* {t("common:translation.Field is required")} */}
                Field is required
              </Text>
            )}
          </View>

          <View style={styles.container}>
            {/* First Field */}
            <View style={{ marginTop: 20 }}>
              <Text style={[Appstyles.EmailidTxt, { marginLeft: 20 }]}>
                Nationality <Text style={{ color: AppColors.red }}>*</Text>
              </Text>
              <TouchableOpacity onPress={() => setFirstFieldModalVisible(true)}>
                <View
                  style={{
                    borderRadius: 10,
                    borderWidth: 1,
                    borderColor: "#F6EFE9",
                    marginTop: 10,
                    paddingHorizontal: 0,
                    marginHorizontal: 20,
                    height: 44,
                    alignItems: "center",
                    flexDirection: "row",
                    paddingLeft: 15,
                  }}
                >
                  {sharedCountryCode ? (
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 14,
                      }}
                    >
                      {/* {sharedCountryCode}{"  "} */}
                      {getCountryFlagFromCode(sharedCountryCode)}
                      {"  "}

                      {getCountryNameFromCode(sharedCountryCode)}

                      {/* Display selected country name and code */}
                    </Text>
                  ) : (
                    <Text
                      style={{
                        color: "#8F430080",
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 14,
                      }}
                    >
                      Select Country
                      {/* {t("common:translation.Select Country")} */}
                    </Text>
                  )}
                </View>
              </TouchableOpacity>
              {countryErrorMessage !== "" && (
                <Text
                  style={{
                    color: "red",
                    marginRight: 20,
                    fontSize: 10,
                    fontFamily: AppFonts.OverpassRegular,
                    textAlign: "right",
                  }}
                >
                  {countryErrorMessage}
                </Text>
              )}
              {/* CountrySelectModal for First Field */}
              <Modal visible={firstFieldModalVisible} transparent>
                <View style={styles.modalBackground}>
                  <View style={styles.modalContainer}>
                    <TextInput
                      style={{
                        fontSize: 16,
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassRegular,
                        borderRadius: 10,
                        borderColor: AppColors.brown,
                        borderWidth: 1,
                        paddingLeft: 20,
                        marginBottom: 20,
                      }}
                      placeholder="Search Country"
                      value={searchText}
                      onChangeText={setSearchText}
                    />
                    <FlatList
                      data={filteredCountryCodes}
                      renderItem={({ item }) => (
                        <TouchableOpacity
                          key={item.code}
                          onPress={() => {
                            handleSharedCountryCodeChange(item.code);
                            setFirstFieldModalVisible(false);
                          }}
                        >
                          <View style={{ flexDirection: "row" }}>
                            <Text style={styles.countryFlag}>{item.flag}</Text>
                            <Text style={styles.countryName}>{item.name}</Text>
                          </View>
                          {/* <Text>
                              {`${item.flag} ${item.name} (${item.code})`}
                            </Text> */}
                        </TouchableOpacity>
                      )}
                      keyExtractor={(item) => item.code}
                    />
                  </View>
                </View>
              </Modal>
            </View>

            {/* Second Field */}
            <View style={{ marginTop: 5 }}>
              <Text style={[Appstyles.EmailidTxt, { marginLeft: 20 }]}>
                Contact Number <Text style={{ color: AppColors.red }}> *</Text>
              </Text>
              <TouchableOpacity
              //  onPress={() => setSecondFieldModalVisible(true)}
              >
                <View
                  style={{
                    borderRadius: 10,
                    borderWidth: 1,
                    borderColor: "#F6EFE9",
                    marginTop: 10,
                    paddingHorizontal: 0,
                    marginHorizontal: 20,
                    flexDirection: "row",
                    alignItems: "center",
                    height: 46,
                    paddingLeft: 15,
                    //  flex: 1,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setSecondFieldModalVisible(true)}
                  >
                    {sharedCountryCode ? (
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontFamily: AppFonts.OverpassRegular,
                          fontSize: 14,
                          //  marginLeft:10
                        }}
                      >
                        {secondFieldCountryCode}
                      </Text>
                    ) : null}
                  </TouchableOpacity>
                  <TextInput
                    style={{
                      fontSize: 14,
                      fontFamily: AppFonts.OverpassRegular,
                    }}
                    onChangeText={(text) => {
                      setCustomerMobile(text);
                      validateForm();
                    }}
                    value={customerMobile}
                    // placeholder={t(
                    //   "common:translation.Enter your Contact Number"
                    // )}
                    placeholder={"Enter your Contact Number"}
                    placeholderTextColor={AppColors.dualbrown}
                    textAlignVertical="top"
                    keyboardType="phone-pad"
                  />
                </View>
                {customerMobileError && isSubmitTouched && (
                  <Text
                    style={{
                      color: "red",
                      marginRight: 20,
                      fontSize: 10,
                      fontFamily: AppFonts.OverpassRegular,
                      textAlign: "right",
                    }}
                  >
                    Field is required
                    {/* {t("common:translation.Field is required")} */}
                  </Text>
                )}
              </TouchableOpacity>

              {/* CountrySelectModal for Second Field */}
              <Modal visible={secondFieldModalVisible} transparent>
                <View style={styles.modalBackground}>
                  <View style={styles.modalContainer}>
                    <TextInput
                      style={{
                        fontSize: 16,
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassRegular,
                        borderRadius: 10,
                        borderColor: AppColors.brown,
                        borderWidth: 1,
                        paddingLeft: 20,
                        marginBottom: 20,
                      }}
                      placeholder="Search Country"
                      value={searchText}
                      onChangeText={setSearchText}
                    />
                    <FlatList
                      data={filteredCountryCodes}
                      renderItem={({ item }) => (
                        <TouchableOpacity
                          key={item.code}
                          onPress={() => {
                            setSecondFieldCountryCode(item.code);
                            setSecondFieldModalVisible(false);
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <View style={{ flexDirection: "row" }}>
                              <Text style={styles.countryFlag}>
                                {item.flag}
                              </Text>
                              <Text style={styles.countryCode}>
                                {item.code}
                              </Text>
                            </View>
                            <View style={{}}>
                              <Text style={styles.countryName}>
                                {item.name}
                              </Text>
                            </View>
                          </View>
                        </TouchableOpacity>
                      )}
                      keyExtractor={(item) => item.code}
                    />
                  </View>
                </View>
              </Modal>
            </View>
          </View>

          <View style={{ marginTop: 20 }}>
            <Text style={[Appstyles.EmailidTxt, { marginLeft: 20 }]}>
              {/* {t("common:translation.City ")} */}
              City
              <Text style={{ color: AppColors.red }}>*</Text>
            </Text>

            <TextInput
              style={[Appstyles.EmailTextinput]}
              onChangeText={(text) => {
                setCustomerCity(text);
                setCustomerCityError(false); // Reset the error state when text is entered
                validateForm();
              }}
              value={customerCity}
              // placeholder={t("common:translation.Enter a Location")}
              placeholder={"Enter a Location"}
              placeholderTextColor={AppColors.dualbrown}
              textAlignVertical="top"
            />
            {customerCityError && isSubmitTouched && (
              <Text
                style={{
                  color: "red",
                  marginRight: 20,
                  fontSize: 10,
                  fontFamily: AppFonts.OverpassRegular,
                  textAlign: "right",
                }}
              >
                {/* {t("common:translation.Field is required")} */}
                {"Field is required"}
              </Text>
            )}
          </View>

          <TouchableOpacity onPress={handleSubmit}>
            <View style={[Appstyles.LoginButton, { marginBottom: 0 }]}>
              <Text style={Appstyles.LoginTxt}>
                {/* {t("common:translation.Try It Now")} */}
                Try It Now
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      </ScrollView>
      <View style={{}}></View>
    </SafeAreaView>
  );
};

export default Registration;

const styles = StyleSheet.create({
  container: {
    // right: 30,
    // backgroundColor: 'green',
    // marginHorizontal: 10,
    // borderColor: '#0674C44D',
    // borderWidth: 1,
    // borderBottomLeftRadius: 10,
    //  borderTopRightRadius: 10,
    // marginTop: 10,
    // width: '30%',
    // flexDirection: "row",
    // alignItems: "center",
  },
  input: {
    // flexDirection: 'row',
    // alignItems: 'center',
    //paddingHorizontal: 10,
    //height: 46,
    // paddingVertical:10
  },
  selectedCountryText: { color: "#8F430080" },
  dropdownIcon: {
    width: 20,
    height: 20,
    alignItems: "center",
    color: AppColors.dualbrown,
    fontFamily: AppFonts.OverpassRegular,
  },
  modalContainer: {
    // flex: 1,
    backgroundColor: "white",
    padding: 20,
    // marginHorizontal: 20,
  },
  countryItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 5,
  },
  countryName: {
    // flex: 1,
    fontSize: 16,
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
    // width: "80%",
    marginLeft: 20,
  },
  countryFlag: {
    fontSize: 20,
    marginLeft: 20,
    fontSize: 16,
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
  },
  countryCode: {
    fontSize: 16,
    color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
    marginLeft: 20,
  },
  closeButton: {
    alignItems: "center",
    paddingVertical: 15,
    borderTopColor: "#CCC",
    borderTopWidth: 1,
  },
  closeButtonText: {
    fontSize: 16,
    color: "#007AFF",
  },
});
